const CountryDetailShimmer = () => {
  return (
    <>
      <div className='country-detail-card-shimmer'>
        <div className='button'></div>
        <div className='country-details-container-shimmer'>
            <div className='image'></div>
            <div className='country-details-shimmer'>
                <h1></h1>
                <div className='details-shimmer'>
                    <p></p>
                    <p></p>
                    <p></p>
                    <p></p>
                    <p></p>
                    <p></p>
                    <p></p>
                </div>
            </div>
        </div>
      </div>
    </>
  )
}

export default CountryDetailShimmer
